import React, { useState, useEffect } from 'react';
import { Auth, API } from "aws-amplify";
import { useSnackbar } from 'notistack';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { DataGrid } from '@mui/x-data-grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Typography } from '@material-ui/core';
import { useHistory } from "react-router-dom";

import RestartAnmodning from '../components/Anmodning._RestartAnmodning';
import AutoRefresh from '../components/AutoRefresh';
import LoadingWrapper from '../components/LoadingWrapper';
import AnmodningStatusPill from '../components/AnmodningStatusPill';
import { useContainerStyles } from '../styles/commonStyles';

const anmoning_columns = [
    { field: 'age', headerName: 'Alder', flex: 1 },
    { 
        field: 'anmod_status', 
        headerName: 'Status', 
        flex: 1,
        renderCell: (params) => <AnmodningStatusPill status={params.value} />
    },
    { field: 'graveforespoergselsnr', headerName: 'Forespørgselsnr.', flex: 1 },
    { field: 'interesseomraadeid', headerName: 'interesseområde', flex: 1 },
    { field: 'vendor_alias', headerName: 'Profil', flex: 1 },
    { 
        field: 'queries_remaining', 
        headerName: 'Kilder mangler', 
        flex: 1,
        renderCell: (params) => (
            <span style={{ color: params.value > 0 ? 'red' : 'inherit' }}>
                {params.value}
            </span>
        )
    },
    { field: 'queries_done', headerName: 'Kilder hentet', flex: 1 },
    { 
        field: 'has_errors', 
        headerName: 'Valideringsfejl', 
        flex: 1,
        renderCell: (params) => (
            <span style={{ color: params.value > 0 ? 'red' : 'inherit' }}>
                {params.value}
            </span>
        )
    },
    { 
        field: 'complete', 
        headerName: 'Pakke dannet', 
        flex: 1,
        renderCell: (params) => (
            <span style={{ color: params.value === false ? 'red' : 'inherit' }}>
                {params.value ? 'Ja' : 'Nej'}
            </span>
        )
    }, 
    { field: 'message', headerName: 'Sidste status', flex: 2 },
];

const dataStores_columns = [
    { field: 'ds_alias', headerName: 'Datastore', flex: 1 },
    { field: 'ds_status_message', headerName: 'Datastore status', flex: 1 },
    { field: 'alias', headerName: 'FeatureType', flex: 2 },
    { field: 'status_message', headerName: 'Feature Message', flex: 6 },

]

const reminders_columns = [
    { field: 'anmod_count', headerName: 'Antal anmodninger', flex: 1 },
    { field: 'interesse', headerName: 'Interesse id', flex: 1 },
    { field: 'last_check', headerName: 'Sidste check', flex: 1 },
    { field: 'rykker_count', headerName: 'Antal rykkere', flex: 1 },
    { field: 'vendor_alias', headerName: 'Vendor', flex: 6 },
]

export default function Monitor({ ...props }) {
    const classes = useContainerStyles();
    const defaultAnmodninger = []
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState([false, '']);
    const [anmodninger, setAnmodninger] = useState(defaultAnmodninger);
    const [dataStores, setDataStores] = useState([]);
    const [reminders, setReminders] = useState([]);
    const history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [expanded, setExpanded] = useState(true);

    const [anmodningRowIds, setAnmodningRowIds] = useState([]);

    const handleExpansionChange = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true)
            await loadData()
            setIsLoading(false)
        }
        fetchData()
    }, [props.vendor_id])

    async function getData() {
        let init = {
            headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
        }
        return await API.post("API", "/Anmodninger/Problems", init);
    }

    async function loadData() {
        setIsLoading(true)
        await getData()
            .then(response => {
                setAnmodninger(response.data.anmodninger.data);
                setDataStores(response.data.datastore.data);
                setReminders(response.data.reminders.data);
            })
            .catch(response => {
                enqueueSnackbar('Kunne ikke hente anmodninger: ' + response.messsage, { variant: 'error', });
                setIsError([true, response.messsage]);
                setAnmodninger(defaultAnmodninger);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    async function openAnmodning(e) {
        await props.setVendorByName(e.row.vendor_alias).then(
            response => {
                history.push('/anmodning/' + e.id);
            }
        );
    }

    function openDatastore(e) {
        props.setVendorID(e.row.vendor_id);
        history.push('/setup/');
    }

    function handleSelectedRows(ids) {
        setAnmodningRowIds(ids);
    }


    async function refresh() {
        setIsLoading(true);
        await loadData();
    }

    return (
        <div className={classes.root}>
            <AutoRefresh onRefresh={refresh} disabled={isLoading} />
            <LoadingWrapper isLoading={isLoading}>
            <Card disabled={isLoading} raised style={{ marginTop: "20px" }} >
                <CardContent>
                    <Accordion expanded={expanded}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={handleExpansionChange} >
                            <Typography variant="h6">Aktive anmodninger ({anmodninger.length})</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div style={{ width: '100%', height: '90%',marginTop:'8px' }}>
                                <Typography >Klik på række åbner side for anmodningen </Typography>
                                <DataGrid style={{ marginTop:'8px' }}
                                    checkboxSelection
                                    getRowId={(row) => row.anmod_id}
                                    rows={anmodninger} columns={anmoning_columns}
                                    onRowSelectionModelChange={(ids) => handleSelectedRows(ids)}
                                    onRowClick={openAnmodning}
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 25 }},
                                    }}
                                    sx={{
                                        boxShadow: 1,
                                        '& .MuiDataGrid-cell:hover': {
                                            color: 'primary.main',
                                            cursor: 'pointer'
                                        },
                                    }}
                                    pageSizeOptions={[10, 25, 100]}
                                />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <RestartAnmodning anmodningRowIds={anmodningRowIds} onAccecpt={loadData} infoTxt="Vælg metode og tryk genstart"  />
                </CardContent>
            </Card>

            {dataStores.length > 0 && (
                <Card disabled={isLoading} raised style={{ marginTop: "20px" }}  >
                    <CardContent>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h6">Featuretypes med fejl ({dataStores.length})</Typography>
                            </AccordionSummary>
                            <AccordionDetails >
                                <div style={{ width: '100%', height: '90%' }}>
                                    <Typography >Klik på række åbner side for vendor profil </Typography>
                                    <DataGrid
                                       
                                        getRowId={(row) => row.ft_id}
                                        disabled={isLoading}
                                        rows={dataStores} columns={dataStores_columns}
                                        onRowClick={openDatastore}
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 5 } },
                                        }}
                                        sx={{
                                            boxShadow: 1,
                                            '& .MuiDataGrid-cell:hover': {
                                                color: 'primary.main',
                                                cursor: 'pointer'
                                            },
                                        }}
                                        pageSizeOptions={[5, 10, 25, 100, 500]}
                                    />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </CardContent>
                </Card>
            )}

            {reminders.length > 0 && (
            <Card disabled={isLoading} raised style={{ marginTop: "20px" }}  >
                <CardContent>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>

                            <Typography variant="h6" gutterBottom>Antal rykkere ved sidste forespørgsel ({reminders.length}) </Typography>
                        </AccordionSummary>
                        <AccordionDetails  >
                            <div style={{ width: '100%' }}>
                                <DataGrid
                                    getRowId={(row) => row.index}
                                    disabled={isLoading}
                                    rows={reminders} columns={reminders_columns}
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 5 } },
                                    }}
                                    sx={{
                                        borderColor: 'primary.light',
                                        '& .MuiDataGrid-cell:hover': {
                                            color: 'primary.main'
                                        },
                                    }}
                                    pageSizeOptions={[5, 10, 25, 100, 500]}
                                />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </CardContent>
            </Card>
            )}
            </LoadingWrapper>
        </div>
    );
}